module.exports = __webpack_public_path__ + "img/4.510948a1.png";